module.exports = __webpack_public_path__ + "img/em-invoicemonitor-01.7f013bfc.jpeg";